(() => {
  const mq = window.matchMedia('(max-width: 749px)');
  const root = document.documentElement;

  const chapters = () => Array.from(document.querySelectorAll('.cb-pdp-mobile-chapter'));

  const setPanelState = (chapter, collapsed) => {
    const button = chapter.querySelector(':scope > .cb-pdp-mobile-chapter__summary');
    const panel = chapter.querySelector(':scope > .cb-pdp-mobile-chapter__content');
    if (!button || !panel) return;

    if (collapsed) {
      button.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
      chapter.classList.remove('is-open');
    } else {
      button.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      chapter.classList.add('is-open');
    }
  };

  const sectionWrapper = (selector) => {
    const node = document.querySelector(selector);
    return node?.closest('.shopify-section, [id^="shopify-section-"]') || null;
  };

  const applyMobileSectionOrder = (isMobile) => {
    const business = sectionWrapper('.cb-pdp-mobile-chapter--business');
    const related = sectionWrapper('.cb-related-sizes--phase2');
    if (!business || !related || business.parentNode !== related.parentNode) return;

    const parent = business.parentNode;
    if (isMobile) {
      if (business.nextElementSibling !== related) parent.insertBefore(business, related);
    } else if (related.nextElementSibling !== business) {
      parent.insertBefore(related, business);
    }
  };

  const applyViewport = () => {
    const isMobile = mq.matches;
    chapters().forEach((chapter) => setPanelState(chapter, isMobile));
    applyMobileSectionOrder(isMobile);
    root.classList.toggle('cb-pdp-mobile-chapters-ready', isMobile);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.cb-pdp-mobile-chapter__summary');
    if (!button || !mq.matches) return;

    const chapter = button.closest('.cb-pdp-mobile-chapter');
    const panel = chapter?.querySelector(':scope > .cb-pdp-mobile-chapter__content');
    if (!chapter || !panel) return;

    const willOpen = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', String(willOpen));
    panel.hidden = !willOpen;
    chapter.classList.toggle('is-open', willOpen);
  });

  applyViewport();
  if (typeof mq.addEventListener === 'function') mq.addEventListener('change', applyViewport);
  else if (typeof mq.addListener === 'function') mq.addListener(applyViewport);

  document.addEventListener('shopify:section:load', applyViewport);
})();
